module.exports = __webpack_public_path__ + "img/globe_b.4e84a27e.svg";